import {
  Transport,
  createBaseTransport,
  createXResolveProvider,
} from '@spotify-internal/transport';
import { useEffect, useMemo } from 'react';
import { LoginState, useUser } from './user/useUser';

export const useTransport = () => {
  const { getToken, loginState } = useUser();

  const transport: Transport = useMemo(
    () =>
      createBaseTransport({
        providers: {
          endpoints: createXResolveProvider(),
          token: () => (getToken ? getToken() : Promise.resolve('')),
        },
      }),
    [getToken],
  );

  useEffect(() => {
    if (loginState === LoginState.LOGGEDIN) {
      transport.connect().then(() => {
        // Authenticate after connection
        transport.authenticate().catch(error => {
          // ignore when logged out
          if (error.message === 'logged out') return;
          throw error;
        });
      });
    }
  }, [transport, loginState]);

  return transport;
};
